import {
    UsersIcon,
    CubeIcon,
    TruckIcon,
    BuildingOfficeIcon,
    ClockIcon,
    CheckCircleIcon,
} from '@heroicons/react/24/outline'
import { colorMap } from '../../../Common'

const CardMetricas = ({ dataMetricas, color = 'blue' }) => {
    // Seleciona as classes baseadas na cor fornecida, com fallback para blue
    const colorClasses = colorMap[color] || colorMap.blue

    // Função para mapear ícones baseado no nome
    const getIconByType = (iconType) => {
        switch (iconType) {
            case 'box': return CubeIcon
            case 'truck': return TruckIcon
            case 'users': return UsersIcon
            case 'check-circle': return CheckCircleIcon
            case 'building': return BuildingOfficeIcon
            case 'clock': return ClockIcon
            default: return CubeIcon
        }
    }

    // Mapeamento de cores individuais para classes Tailwind completas
    const getColorClassesByType = (colorType) => {
        const colorMapLocal = {
            blue: {
                iconBg: 'bg-brand-cyan/20',
                iconText: 'text-brand-cyan-dark'
            },
            green: {
                iconBg: 'bg-brand-cyan/20',
                iconText: 'text-brand-cyan-dark'
            },
            orange: {
                iconBg: 'bg-brand-cyan/20',
                iconText: 'text-brand-cyan-dark'
            },
            purple: {
                iconBg: 'bg-brand-cyan/20',
                iconText: 'text-brand-cyan-dark'
            },
            red: {
                iconBg: 'bg-brand-cyan/20',
                iconText: 'text-brand-cyan-dark'
            },
            yellow: {
                iconBg: 'bg-brand-cyan/20',
                iconText: 'text-brand-cyan-dark'
            },
            indigo: {
                iconBg: 'bg-brand-cyan/20',
                iconText: 'text-brand-cyan-dark'
            },
            pink: {
                iconBg: 'bg-brand-cyan/20',
                iconText: 'text-brand-cyan-dark'
            },
            emerald: {
                iconBg: 'bg-brand-cyan/20',
                iconText: 'text-brand-cyan-dark'
            },
            teal: {
                iconBg: 'bg-brand-cyan/20',
                iconText: 'text-brand-cyan-dark'
            },
            cyan: {
                iconBg: 'bg-brand-cyan/20',
                iconText: 'text-brand-cyan-dark'
            }
        }

        return colorMapLocal[colorType] || colorMapLocal.blue
    }


    return (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-3 gap-4 mb-8">
            {dataMetricas && dataMetricas.length > 0 && dataMetricas.map((stat, index) => {
                const IconComponent = getIconByType(stat.icon)
                return (
                    <div key={index} className="bg-white border border-gray-100 rounded-2xl p-5 shadow-sm">
                        <div className="flex items-center justify-between mb-4">
                            <div className="p-2.5 bg-brand-yellow/15 rounded-xl">
                                <IconComponent className="w-5 h-5 text-gray-900" />
                            </div>
                        </div>
                        <p className="text-2xl font-bold text-gray-900">{stat.value}</p>
                        <p className="text-xs text-gray-400 mt-0.5">{stat.title}</p>
                    </div>
                )
            })}
        </div>
    )
}



export default CardMetricas